import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { Navbar, Sidebar, ThemeSettings } from './components';
import Ecommerce from './pages/Ecommerce';
import OrdersManagement from './customPages/OrdersManagement';
import Products from './customPages/Products';
import StockManagement from './customPages/StockManagement';
import TeamMembers from './customPages/TeamMembers'; // Updated import
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import UsersManagementPage from './customPages/UsersManagementPage';
import ProtectedPage from './components/ProtectedPage'; // Adjusted path
import OrderHub from './customPages/OrderHub';
import Orders from './pages/Orders';
import StaffMaster from './components/StaffMaster';
import CompanyMaster from './pages/CompanyMaster';
import CourierProcessTab1 from './pages/CourierProcessTab1';
import CourierProcessPage from './pages/CourierProcessPage';
//import ThemeSettings from './components';
import TaskAssignPage from './pages/TaskAssignPage';

import './App.css';
import { useStateContext } from './contexts/ContextProvider';
import CourierManagement from './pages/CourierManagement';
import UploadTask from './pages/UploadTask';
import ReassignTask from './pages/ReassignTask';
import ServersMaster from './pages/ServersMaster';
import ToPackPage from './components/ToPackPage';
import LetsSee from './pages/LetsSee';
import HandoverPage from './components/HandoverPage';

// Shared password for protected pages
const SHARED_PASSWORD = 'securePassword123';

// Ensure authToken exists in localStorage
if (!localStorage.getItem('authToken')) {
  console.error('No authToken found! Please log in.');
}

const App = () => {
  const { activeMenu } = useStateContext();
  const isAuthenticated = localStorage.getItem('authToken'); // Check if user is authenticated

  return (
    <BrowserRouter>
      <div className={`flex relative dark:bg-main-dark-bg`}>
        {isAuthenticated && activeMenu ? (
          <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
        <div
          className={`dark:bg-main-bg bg-main-bg min-h-screen w-full ${
            isAuthenticated && activeMenu ? 'md:ml-72' : 'flex-2'
          }`}
        >
          {isAuthenticated && (
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
              <Navbar />
            </div>
          )}
          <Routes>
            {/* Login Route */}
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />}
            />
  
            {/* Public Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Ecommerce />
                  
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders-management"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <OrdersManagement />
                </ProtectedRoute>
              }
            />


<Route
              path="/to-pack"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ToPackPage />
                  </ProtectedRoute>
              }
            />

            {/* Password-Protected Pages */}
            <Route
              path="/products"
              element={
                <ProtectedPage pageKey="products" sharedPassword={SHARED_PASSWORD}>
                  <Products />
                </ProtectedPage>
              }
            />
            <Route
              path="/stock-management"
              element={
                <ProtectedPage pageKey="stock-management" sharedPassword={SHARED_PASSWORD}>
                  <StockManagement />
                </ProtectedPage>
              }
            />
            <Route
              path="/team-members"
              element={
                <ProtectedPage pageKey="team-members" sharedPassword={SHARED_PASSWORD}>
                  <TeamMembers />
                </ProtectedPage>
              }
            />
            <Route
              path="/users-management"
              element={
                <ProtectedPage pageKey="users-management" sharedPassword={SHARED_PASSWORD}>
                  <UsersManagementPage />
                </ProtectedPage>
              }
            />
            <Route
              path="/order-hub"
              element={
                <ProtectedPage pageKey="order-hub" sharedPassword={SHARED_PASSWORD}>
                  <OrderHub />
                </ProtectedPage>
              }
            />
 <Route
              path="/staff"
              element={
                <ProtectedPage pageKey="staff" sharedPassword={SHARED_PASSWORD}>
                  <StaffMaster />
                </ProtectedPage>
              }
            />


<Route
              path="/companies"
              element={
                <ProtectedPage pageKey="companies" sharedPassword={SHARED_PASSWORD}>
                  <CompanyMaster />
                </ProtectedPage>
              }
            />

<Route
              path="/couriers"
              element={
                <ProtectedPage pageKey="couriers" sharedPassword={SHARED_PASSWORD}>
                  <CourierManagement />
                </ProtectedPage>
              }
            />


<Route
              path="/courier-process-tab1"
              element={
                <ProtectedPage pageKey="courier-process-tab1" sharedPassword={SHARED_PASSWORD}>
                  <CourierProcessTab1 />
                </ProtectedPage>
              }
            />

            
<Route
              path="/courier-process"
              element={
                <ProtectedPage pageKey="courier-process" sharedPassword={SHARED_PASSWORD}>
                  <CourierProcessPage />
                </ProtectedPage>
              }
            />

<Route
              path="/upload-task"
              element={
                <ProtectedPage pageKey="upload-task" sharedPassword={SHARED_PASSWORD}>
                  <UploadTask />
                </ProtectedPage>
              }
            />



<Route
              path="/assign-task"
              element={
                <ProtectedPage pageKey="assign-task" sharedPassword={SHARED_PASSWORD}>
                  <TaskAssignPage />
                </ProtectedPage>
              }
            />

<Route
              path="/reassign-task"
              element={
                <ProtectedPage pageKey="reassign-task" sharedPassword={SHARED_PASSWORD}>
                  <ReassignTask />
                </ProtectedPage>
              }
            />


<Route
              path="/Verify-Orders"
              element={
                <ProtectedPage pageKey="Verify Orders" sharedPassword={SHARED_PASSWORD}>
                  <LetsSee />
                  </ProtectedPage>
              }
            />
          

          <Route
              path="/servers"
              element={
                <ProtectedPage pageKey="servers" sharedPassword={SHARED_PASSWORD}>
                  <ServersMaster />
                  </ProtectedPage>
              }
            />


<Route
              path="/handover"
              element={
                <ProtectedPage pageKey="handover" sharedPassword={SHARED_PASSWORD}>
                  <HandoverPage />
                  </ProtectedPage>
              }
            />


          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
